import { useLocation } from 'react-router-dom';
import querystring, { ParsedQuery } from 'query-string';

export function useQueryParams<Params extends ParsedQuery>(): Params {
  const { search } = useLocation();
  const params = querystring.parse(search);
  return params as Params;
}
